export default __webpack_public_path__ + "media/images/about_us/woman-smile-ff39dfa42913e4e11968d0d3b11df9f4.png";